import { arrondi } from './vat';

/**
 * L'acompte déjà reçu, en francs, à partir de ce que le patron a écrit : le
 * montant en CHF, ou le pourcentage du total TTC au centime.
 *
 * @param {object} form formulaire de la facture
 * @param {number} ttc total TTC de la facture
 * @returns {number} le montant reçu, zéro sans acompte
 */
export function acompteRecuDe(form, ttc) {
  const brut = form.acompteRecuEnFrancs
    ? +form.acompteRecuMontant || 0
    : ((+form.acompteRecu || 0) * (+ttc || 0)) / 100;
  return arrondi(Math.max(0, Math.min(brut, +ttc || 0)), 2);
}

/**
 * L'acompte demandé sur une facture, en francs : le montant écrit (borné au
 * total), ou le pourcentage du total au centime, comme le serveur.
 *
 * @param {object} f facture
 * @param {number} ttc total TTC de la facture
 * @returns {number} l'acompte à payer avant le solde, zéro sans acompte
 */
export function acompteDemandeDe(f, ttc) {
  if (+f?.acompteDemandeMontant > 0)
    return arrondi(Math.min(+f.acompteDemandeMontant, +ttc || 0), 2);
  const pct = +f?.acompteDemande || 0;
  return pct > 0 ? arrondi(((+ttc || 0) * pct) / 100, 2) : 0;
}
